// JOBE-0167.2: MemoryList — list-of-rows surface for the Memories tab.
//
// States: loading · loaded (rows or empty) · error.
// Above the list: summary line. Below: optional "Load more" affordance.

import { MemoryListRow } from './MemoryListRow.jsx';

/**
 * @param {object} props
 * @param {'loading'|'loaded'|'error'} props.state
 * @param {Array<object>} props.memories
 * @param {number} [props.totalCount]
 * @param {number} [props.hiddenByFilter]
 * @param {string|null} [props.nextCursor]
 * @param {() => void} props.onReset
 * @param {() => void} props.onRetry
 * @param {() => void} props.onLoadMore
 * @param {(urn: string) => void} props.onExpand
 */
export function MemoryList({
  state,
  memories = [],
  totalCount,
  hiddenByFilter = 0,
  nextCursor = null,
  onReset,
  onRetry,
  onLoadMore,
  onExpand,
}) {
  if (state === 'loading') {
    return (
      <div className="memory-list" data-testid="memory-list">
        <div className="memory-list__loading" data-testid="memory-list-loading">
          Loading memories…
        </div>
      </div>
    );
  }

  if (state === 'error') {
    return (
      <div className="memory-list" data-testid="memory-list">
        <div className="memory-list__error" data-testid="memory-list-error">
          Could not load memories ·{' '}
          <button
            type="button"
            className="memory-list__retry"
            data-testid="memory-list-retry"
            onClick={onRetry}
          >
            Retry
          </button>
        </div>
      </div>
    );
  }

  const n = totalCount != null ? totalCount : memories.length;

  if (memories.length === 0) {
    return (
      <div className="memory-list" data-testid="memory-list">
        <div className="memory-list__empty" data-testid="memory-list-empty">
          No memories match these filters ·{' '}
          <button
            type="button"
            className="memory-list__reset-link"
            data-testid="memory-list-reset"
            onClick={onReset}
          >
            Reset filters
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="memory-list" data-testid="memory-list">
      <div className="memory-list__summary" data-testid="memory-list-summary">
        {n} memories
        {hiddenByFilter > 0 ? ` · ${hiddenByFilter} hidden by filter` : ''}
        {' · '}
        <button
          type="button"
          className="memory-list__reset-link"
          data-testid="memory-list-reset"
          onClick={onReset}
        >
          Reset filters
        </button>
      </div>
      <ul className="memory-list__rows" data-testid="memory-list-rows">
        {memories.map((m) => (
          <li key={m.urn} className="memory-list__row-wrap">
            <MemoryListRow memory={m} onExpand={onExpand} />
          </li>
        ))}
      </ul>
      {nextCursor && (
        <div className="memory-list__more">
          <button
            type="button"
            className="memory-list__load-more"
            data-testid="memory-list-load-more"
            onClick={onLoadMore}
          >
            Load more
          </button>
        </div>
      )}
    </div>
  );
}

export default MemoryList;
